import { initGraphQLTada } from 'gql.tada';

import type { introspection } from './graphql-env';

/**
 * gql.tada instance bound to the Medplum FHIR R4 GraphQL schema
 * (`/fhir/R4/$graphql`). No `scalars` config: Medplum maps FHIR primitives
 * to built-in GraphQL scalars (`date`/`dateTime`/`code`/etc. → String,
 * `integer`/`decimal` → Float), so there are no custom scalars to map.
 */
export const graphql = initGraphQLTada<{
  introspection: introspection;
}>();

export type { FragmentOf, ResultOf, VariablesOf } from 'gql.tada';
export { readFragment } from 'gql.tada';
